@if (shouldDisplayTeaser$ | async) {
  @if (depotFacade.savingsPlanTeaserProducts$ | async; as products) {
    @if (products?.length) {
      <div class="row" data-zid="savings-plan-teaser">
        <div class="col-12">
          <div class="tile">
            <div class="close" (click)="dismiss()" data-zid="savings-plan-teaser-dismiss">
              <span aria-hidden="true">×</span>
            </div>
            <h5 class="mb-3">{{ 'first-savings-plan-teaser.headline' | transloco }}</h5>
            <p>{{ 'first-savings-plan-teaser.text' | transloco }}</p>
            <div class="row justify-content-between">
              @for (product of products; track product.isin) {
                <div class="col-12 col-md-6 col-lg-3 mb-2 mb-lg-0" data-zid="savings-plan-teaser-product">
                  <web-design-system-button size="small" type="secondary" [fullwidth]="true" [routerLink]="[savingsPlanForm, product.isin]">
                    {{ product.name }}
                  </web-design-system-button>
                </div>
              }
              <div class="col-12 col-md-6 col-lg-3 mb-2 mb-lg-0 d-flex align-items-center justify-content-center">
                <a class="link-secondary text-default" [routerLink]="savingsPlanHome">
                  {{ 'first-savings-plan-teaser.own' | transloco }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  }
}
